import { markPerformance, measurePerformance } from '../performance';

import { AdParams, AdSlotsConfigurationByPlatform, AdSlotsUnits } from './ads.types';

declare global {
  interface Window { googletag: googletag.Googletag }
}

declare global {
  interface Window { mmClientApi: { push: (eventName: string, params: any) => void } }
}

export const googleTagServerName = 'googletag';

let adSlots = [] as googletag.Slot[];

export const getGoogleTag = () => {
  window.googletag = window.googletag || {};
  window.googletag.cmd = window.googletag.cmd || [];
  return window.googletag;
};

export const getConstructedUnitPath = (adUnitPath: string, adsCategory: string) => {
  return adUnitPath.replace('{}', adsCategory);
};

export const gptDefineSlots = (adSlotsConfigurationByPlatform: AdSlotsConfigurationByPlatform, units: AdSlotsUnits, adsCategory: string) => {
  const googletag = getGoogleTag();
  adSlots = [];
  Object.entries(adSlotsConfigurationByPlatform).forEach((([unitKey, unitConf]) => {
    const { adUnitPath, sizes } = unitConf;
    const finalAdUnitPath = getConstructedUnitPath(adUnitPath, adsCategory);
    let adSlot = null;
    googletag.cmd.push(() => {
      adSlot = googletag.defineSlot(finalAdUnitPath, sizes, units[unitKey])
        .setCollapseEmptyDiv(true)
        .addService(googletag.pubads());
      adSlots = adSlot ? [...adSlots, adSlot] : adSlots;
    });
  }));
  googletag.cmd.push(() => {
    googletag.pubads().disableInitialLoad();
    googletag.enableServices();
  });
};

export const gptDisplayAds = (units: AdSlotsUnits) => {
  const googletag = getGoogleTag();
  Object.values(units).forEach((unitId => {
    googletag.cmd.push(() => {
      googletag.display(unitId);
    });
  }));
};
export const gptSetRequestNonPersonalizedAds = (shouldNotPersonalizeAds: boolean) => {
  const googletag = getGoogleTag();
  googletag.cmd.push(() => {
    googletag.pubads().setRequestNonPersonalizedAds(shouldNotPersonalizeAds ? 1 : 0);
  });
};

export const gptSetTargeting = (params: AdParams) => {
  const googletag = getGoogleTag();
  Object.entries(params).forEach(([key, value]) => {
    googletag.cmd.push(() => {
      googletag.pubads().setTargeting(key, value);
    });
  });
};

export const gptRefreshCallback = (headerBiddingCallback: Function) => {
  return () => {
    const googletag = getGoogleTag();
    googletag.cmd.push(() => {
      headerBiddingCallback();
      if (adSlots.length > 0) {
        googletag.pubads().refresh(adSlots);
      }
    });
  };
};

export const gptSetViewableEvents = () => {
  const googletag = getGoogleTag();
  const adSizes = {} as { [key: string]: string };

  let firstAdLoaded = false;

  googletag.cmd.push(() => {
    googletag.pubads().addEventListener('slotRenderEnded', event => {
      if (!event.isEmpty) {
        const path = event.slot.getAdUnitPath();
        // @ts-ignore
        adSizes[path] = event.size.join(',');
      }
    });

    googletag.pubads().addEventListener('impressionViewable', event => {
      const { slot } = event;
      if (!(event as googletag.events.SlotRenderEndedEvent).isEmpty) {
        window.mmClientApi = window.mmClientApi || [];
        const { mmClientApi } = window;
        const res = slot.getResponseInformation();
        const path = slot.getAdUnitPath();

        if (!firstAdLoaded) {
          firstAdLoaded = true;
          markPerformance('ad-loaded');
          measurePerformance('time-to-first-ad', 'init-ads', 'ad-loaded');
        }
        mmClientApi.push('analytics', {
          event_category: 'Ads tracking',
          event_action: 'ad impression',
          event_label: path,
          event_size: adSizes[path] as string,
          event_advertiserId: res.advertiserId,
          event_creativeId: res.creativeId,
          event_lineItemId: res.lineItemId,
          // @ts-ignore
          event_sourceAgnosticCreativeId: res.sourceAgnosticCreativeId,
          // @ts-ignore
          event_sourceAgnosticLineItemId: res.sourceAgnosticLineItemId,
          // @ts-ignore
          event_yieldGroupIds: res.yieldGroupIds,
          // @ts-ignore
          event_isBackfill: res.isBackfill,
        });
      }
    });
  });
};
